var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view"},[_c('main',[(!_vm.editing_blocks)?_c('blocks',{attrs:{"blocks":_vm.blocks}}):_vm._e(),_vm._v(" "),(_vm.editing_blocks)?_c('block-editor',{attrs:{"blocks":_vm.blocks,"route_name":_vm.$route.name,"page_slug":_vm.blocks_pagekey},on:{"updated":function($event){return _vm.blocksUpdated()}}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d9b88518","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ArtistList.vue
// module id = null
// module chunks = 